// @flow
import env from '../../../environment';
import {putCreator, postCreator, deleteCreator} from '../../../http';

export const endpoints = Object.freeze({
  SAVE_SETTINGS: `${env.baseApiUrl}/usher/store`,
  SAVE_CUSTOM_IMAGE: `${env.baseApiUrl}/usher/store/logo`,
  SAVE_INFORMATION: `${env.baseApiUrl}/ui/admin/store/information`,
  SAVE_STORE_PROFILE_INFORMATION: `${env.baseApiUrl}/ui/admin/store/profile-information`,
  ADD_CONTACT: `${env.baseApiUrl}/ui/admin/information/contact`,
  SAVE_CONTACT: `${env.baseApiUrl}/ui/admin/store/contact`,
  DELETE_STORE_CONTACT: `${env.baseApiUrl}/ui/admin/store/contact/:storeContactId`,
});

export type SaveGeneralSettingsRequest = {
  name?: string,
  domainName?: string,
};

export type SaveGeneralInformationRequest = {
  imageFile?: File,
  description?: string,
  colorSetting?: {enabled: boolean, color: string},
  coverImageFile?: File | null,
};

export type SaveStoreProfileInformationRequest = {
  description?: string,
  videoUrl?: string,
  profileImageFile?: File | null,
  videoSocialMediaTypeId?: string,
};

export type SaveGeneralContactRequest = {
  contactTypeId: string,
  data: string,
  storeContactId?: string,
};

export const saveGeneralSettingsApi = putCreator(endpoints.SAVE_SETTINGS);
// export const saveCustomImageApi = postCreator(endpoints.SAVE_CUSTOM_IMAGE);
export const saveGeneralInformationApi = postCreator(
  endpoints.SAVE_INFORMATION
);
export const saveStoreProfileInformationApi = postCreator(
  endpoints.SAVE_STORE_PROFILE_INFORMATION
);
// export const addGeneralContact = postCreator(endpoints.ADD_CONTACT);
export const saveGeneralContact = postCreator(endpoints.SAVE_CONTACT);

export const deleteStoreContact = deleteCreator(endpoints.DELETE_STORE_CONTACT);
